// 组件
import Vue from 'vue'

import Notifications from 'vue-notification'
import Toasted from 'vue-toasted'
import Multiselect from 'vue-multiselect'
import InputTag from 'vue-input-tag'
import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
import Datepicker from 'vuejs-datepicker'
import flatPickr from 'vue-flatpickr-component'
import VJstree from 'vue-jstree'
import treeselect from '@riophae/vue-treeselect'
import VueImg from 'v-img'
import VueClipboard from 'vue-clipboard2'

Vue.use(Notifications)
Vue.use(Toasted)
Vue.use(Multiselect)
Vue.use(InputTag)
Vue.use(SweetModal)
Vue.use(SweetModalTab)
Vue.use(Datepicker)
Vue.use(flatPickr)
Vue.use(treeselect)
Vue.use(VueImg, {
  altAsTitle: true
})
Vue.use(VueClipboard)
Vue.component('Multiselect', Multiselect)
Vue.component('InputTag', InputTag)
Vue.component('SweetModal', SweetModal)
Vue.component('SweetModalTab', SweetModalTab)
Vue.component('Datepicker', Datepicker)
Vue.component('flatPickr', flatPickr)
Vue.component('VJstree', VJstree)
Vue.component('treeselect', treeselect)
export default {
  Notifications,
  Toasted,
  Multiselect,
  InputTag,
  SweetModal,
  SweetModalTab,
  Datepicker,
  flatPickr,
  VJstree,
  treeselect
}
